import { endpointsContacts } from '../api/endpoints'
import { API } from './comunApi'

export const contactsApi = {
  newContacts: (params) => API.post(endpointsContacts.NEW_CONTACTS, params),
  getContactById: async (id) => {
    return await API.get(endpointsContacts.GET_CONTACTS_BY_ID(id))
  },
  getContacts: async () => {
    return await API.get(endpointsContacts.GET_ALL_CONTACTS)
  },
  getAllContacts: async () => {
    return await API.get(endpointsContacts.GET_ALL_CONTACTS)
  },
}
